module.exports = __webpack_public_path__ + "static/media/menuIcon.4fd8450c.svg";